import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default function About() {
  const navigate = useNavigate()

  useEffect(() => {
    document.title = 'About ScamView — AI-Powered Job Seeker Protection'
  }, [])

  return (
    <div className="min-h-screen bg-[#0a0e17]">
      <Header />

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="space-y-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1
              className="text-4xl md:text-5xl font-bold text-white mb-4"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              About ScamView
            </h1>
            <p className="text-xl text-gray-300">
              Protecting job seekers from recruitment fraud with AI-powered analysis
            </p>
          </div>

          {/* Mission */}
          <div className="card">
            <h2 className="text-2xl font-bold text-white mb-4">Our Mission</h2>
            <p className="text-gray-300 leading-relaxed">
              Every year, thousands of job seekers fall victim to recruitment scams that waste their time,
              steal their personal information, and damage their finances. ScamView was built to solve this problem
              by providing instant, AI-powered fraud detection that anyone can use.
            </p>
          </div>

          {/* How It Works */}
          <div className="card">
            <h2 className="text-2xl font-bold text-white mb-4">How It Works</h2>
            <div className="space-y-4 text-gray-300">
              <div>
                <h3 className="font-semibold text-white mb-2">1. Multi-Signal Analysis</h3>
                <p>
                  We combine technical verification (DNS, domain age, phone intelligence),
                  content analysis (urgency patterns, financial requests), and community intelligence
                  (web search, scam reports) for comprehensive detection.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-white mb-2">2. AI-Powered Reasoning</h3>
                <p>
                  AI analyzes all signals with specialized prompts calibrated for recruiting context,
                  distinguishing between aggressive-but-legitimate outreach and actual scams.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-white mb-2">3. Defensive Reporting</h3>
                <p>
                  Results show generic risk categories to users while logging specific details internally,
                  preventing scammers from gaming the system.
                </p>
              </div>
            </div>
          </div>

          {/* Privacy & Security */}
          <div className="card">
            <h2 className="text-2xl font-bold text-white mb-4">Privacy & Security</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                <strong className="text-white">Data Privacy:</strong> We store only the email/phone number
                you scan and the analysis results. Message content is analyzed in real-time but not permanently stored.
              </p>
              <p>
                <strong className="text-white">Security:</strong> All data is encrypted in transit and at rest.
                Scan results are tied to your account and are not accessible to other users.
              </p>
              <p>
                <strong className="text-white">No Selling:</strong> We never sell your data to third parties.
                Your scans remain private.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center pt-8">
            <button
              onClick={() => navigate('/dashboard')}
              className="btn-primary text-lg"
            >
              Try ScamView Now
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
